const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Medication/MedicationList.tsx';
import { Typography } from '@mui/material';
import { IMedication, Medication } from './Medication';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';
import { useIntl } from 'react-intl';
import textMap from 'App/components/Medication/translations';
import * as React from 'react';
import PageCardComponent from 'App/components/PageCard/PageCardComponent';
import GoBackToDashboardButton from 'App/pages/GoBackToDashboardButton';

interface IMedicationListProps {
    medications: IMedication[];
}

const gridStyle = css`
    padding: ${theme.spacing(3)};
    padding-top: ${theme.spacing(2)};
    display: grid;
    grid-gap: ${theme.spacing(2)};
    grid-template-columns: repeat(auto-fit, minmax(${theme.spacing(30)}, 1fr));
`;
const currentMedisStyle = css`
    padding-left: ${theme.spacing(3)};
`;

/**
 * Functional React component
 */
export const MedicationList = (props: IMedicationListProps) => {
    const { formatMessage } = useIntl();
    const list = props.medications.map((medication: IMedication, index: number) => (
        <Medication key={`${index}-${medication.title}`} {...medication} />
    ));

    return (
        <>
            <GoBackToDashboardButton />
            <PageCardComponent
                title={formatMessage(textMap.medicationTitle)}
                titleIcon={'icons8-pill-filled'}
                TitleProps={{
                    className: css`
                        margin-bottom: ${theme.spacing(2)};
                    `,
                }}
            >
                <Typography variant="h5" component="span" className={currentMedisStyle}>
                    {formatMessage(textMap.currentMedis)}
                </Typography>
                <div className={gridStyle}>{list}</div>
            </PageCardComponent>
        </>
    );
};
